// Keep tool controls labelled and keyboard-operable; reuse the existing data-popup hooks.
function closeBasketTool(root) {
  root = root || document;
  const popup = root.querySelector('.popup-toolDown.show');
  if (!popup) return;
  popup.classList.remove('show');
  root.querySelector('.previewCart')?.classList.remove('active-tool');
  const button = Array.from(root.querySelectorAll('.cartTool-item')).find(item => item.dataset.popup === popup.id);
  if (button) { button.setAttribute('aria-expanded', 'false'); button.focus({ preventScroll: true }); }
}

class CartTool extends HTMLElement {
  constructor() {
    super();
    const root = this.closest('#halo-cart-sidebar') || document;
    this.querySelectorAll('.cartTool-item').forEach(button => {
      button.addEventListener('click', event => {
        const popup = document.getElementById(event.currentTarget.dataset.popup);
        if (!popup) return;
        const wasOpen = popup.classList.contains('show');
        closeBasketTool(root);
        if (wasOpen) return;
        popup.classList.add('show');
        button.setAttribute('aria-expanded', 'true');
        root.querySelector('.previewCart')?.classList.add('active-tool');
        const focusFirst = () => {
          if (popup.classList.contains('show') && document.activeElement === button) {
            popup.querySelector('input:not([type="hidden"]), textarea, button')?.focus({ preventScroll: true });
          }
        };
        popup.addEventListener('transitionend', focusFirst, { once: true });
        requestAnimationFrame(focusFirst);
        setTimeout(focusFirst, 300);
      });
    });
  }
}
if (!customElements.get('cart-item-tool')) customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    this.querySelector('button')?.addEventListener('click', () => closeBasketTool(this.closest('#halo-cart-sidebar') || document));
  }
}
if (!customElements.get('cart-cancel-popup')) customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      closeBasketTool(this.closest('#halo-cart-sidebar') || document);
    })
  }
}

customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
  constructor() {
    super();
    try {
      this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount') || '';
    } catch (_) { /* Storage may be disabled; checkout still accepts a code. */ }
    this.querySelector('[data-update-coupon]').addEventListener('click', (event) => {
      this.val = this.querySelector('input[name="discount"]').value;
      try { localStorage.setItem('storedDiscount', this.val); } catch (_) {}
      fetch(`${window.Shopify?.routes?.root || '/'}discount/${encodeURIComponent(this.val)}`)
          .then((response) => response.text())
          .then((responseText) => {
        	
      });
      closeBasketTool(this.closest('#halo-cart-sidebar') || document);
      Shopify.getCart((cart) => {window.sharedFunctions?.updateSidebarCart(cart)});
    })
  }
}

customElements.define('coupon-code', CouponCode);